import constants from 'src/common/constants';

export default function () {
  return {
    canInteract: true,
    isBooting: true,
    language: 'is',
    location: constants.DEFAULT_LOCATION_ID,
    all: [],
    locationConfig: {},
  };
}
